import { Spin } from "antd";

const AvatarLoader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="vn-avatar-loader">
      <Spin />
    </div>
  );
};

export default AvatarLoader;